module.exports = __webpack_public_path__ + "img/MGH-Nihonbashi-11-2440x1172.a72e6c96.jpg";